module.exports = __webpack_public_path__ + "da5f57cff79e2bbe89efde36c3eefb97.svg";